// extracted by mini-css-extract-plugin
export default {"switch":"toggle__switch__tLzku","on":"toggle__on___Qxg1","toggle":"toggle__toggle__dn0v9"};